import { render, staticRenderFns } from "./ComparisonCard.vue?vue&type=template&id=c83b456c"
import script from "./ComparisonCard.vue?vue&type=script&lang=js"
export * from "./ComparisonCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports